import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { UpdateVacancyStatusRequest, Vacancy } from '../types';
import { MutationKey, QueryKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { AxiosError } from 'axios';

export const useUpdateVacancyStatus = (
  id: string
): UseMutationResult<
  Vacancy,
  AxiosError<TFormErrorResponse>,
  UpdateVacancyStatusRequest
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKey.UPDATE_VACANCY_STATUS],
    mutationFn: (params: UpdateVacancyStatusRequest) =>
      vacancyApi.updateVacancyStatus(id, params),
    onSuccess: () =>
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) => {
          const dependentKeys: readonly unknown[] = [
            QueryKey.GET_VACANCIES,
            QueryKey.GET_VACANCY,
            QueryKey.GET_VACANCY_STATUS_HISTORY,
            QueryKey.GET_USERS,
            QueryKey.GET_USERS_WITH_PAGINATION,
            QueryKey.GET_USER,
            QueryKey.GET_CANDIDATE,
            QueryKey.GET_CANDIDATES,
            QueryKey.GET_CANDIDATE_VACANCIES,
          ];
          return (
            dependentKeys.includes(queryKey[0]) ||
            (typeof queryKey[0] === 'string' &&
              (queryKey[0] === 'candidate-resume' ||
                queryKey[0].startsWith('candidate-resumes-')))
          );
        },
      }),
  });
};
